// @ts-nocheck

export const localeCodes =  [
  "en-AU",
  "en-CA",
  "fr",
  "en-NZ"
]
export const localeLoaders = {
  "en-AU": [
    {
      key: "locale_en_46js_11d3e38f",
      load: () => import("#nuxt-i18n/11d3e38f" /* webpackChunkName: "locale_en_46js_11d3e38f" */),
      cache: true
    }
  ],
  "en-CA": [
    {
      key: "locale_en_46js_11d3e38f",
      load: () => import("#nuxt-i18n/11d3e38f" /* webpackChunkName: "locale_en_46js_11d3e38f" */),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_46js_8cc47d8f",
      load: () => import("#nuxt-i18n/8cc47d8f" /* webpackChunkName: "locale_fr_46js_8cc47d8f" */),
      cache: true
    }
  ],
  "en-NZ": [
    {
      key: "locale_en_46js_11d3e38f",
      load: () => import("#nuxt-i18n/11d3e38f" /* webpackChunkName: "locale_en_46js_11d3e38f" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en-AU",
    iso: "en-AU",
    currency: "AUD",
    domain: "dev.michaelhill.com.au",
    domainDefault: true,
    language: "English"
  },
  {
    code: "en-CA",
    iso: "en-CA",
    currency: "CAD",
    domain: "dev.michaelhill.ca",
    domainDefault: true,
    language: "English"
  },
  {
    code: "fr",
    iso: "fr-CA",
    currency: "CAD",
    domain: "dev.michaelhill.ca",
    language: "French"
  },
  {
    code: "en-NZ",
    iso: "en-NZ",
    currency: "NZD",
    domain: "dev.michaelhill.co.nz",
    domainDefault: true,
    language: "English"
  }
]

